import AddPosition from './AddPosition'
import Employee from './Employee'
import Link from './Link'
import Position from './Position'

export default {
  Link,
  Employee,
  AddPosition,
  Position,
}
